import { styled } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';
import { QButton } from '@kw/quokka-ui';

interface IProps {
  onClick: () => void;
}

export const AddDeviceOwnerButton = ({ onClick }: IProps) => {
  return (
    <StyledAddDeviceOwnerButton startIcon={<AddIcon />} variant="filled" onClick={onClick} color="primary">
      Add
    </StyledAddDeviceOwnerButton>
  );
};

const StyledAddDeviceOwnerButton = styled(QButton)`
  height: 32px;
  box-shadow: none;
  margin-left: auto;
  float: right;
`;
